module.exports = __webpack_public_path__ + "static/media/pic_story.1fef758a.png";